<div class="input-group search-group {{styleType}} clearfix">
  <input #inputEl
         autocomplete="off"
         type="search"
         name="search"
         class="form-control search-input ws-search-bar__input"
         [class.with-icon-search]="showSearchIcon"
         [placement]="'bottom-start'"
         [(ngModel)]="asyncSelected"
         [ngbTypeahead]="source"
         [resultTemplate]="ngbItemTemplate"
         [resultFormatter]="resultFormatter"
         [inputFormatter]="resultFormatter"
         (selectItem)="typeaheadOnSelect($event)"
         [disabled]="disabled"
         [placeholder]="placeholder || ('locationSearchBar.searchLocationOrBakery' | translate)"
         [attr.aria-label]="placeholder || ('locationSearchBar.searchLocationOrBakery' | translate)"
         (focus)="handleInputFocused()"
         (focusout)="onInputUnfocused()">

  @if (showLoading && typeaheadLoading && lastQuery) {
    <svg class="spinner"
         animate.enter="ui-search-fade-in"
         animate.leave="ui-search-fade-out"
         viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
    </svg>
  }

  @if (showSearchIcon) {
    <div class="input-group-prepend">
      <i class="icon-search"></i>
    </div>
  }

  <button class="search-btn btn btn-pink"
          [attr.aria-label]="placeholder || ('locationSearchBar.searchLocationOrBakery' | translate)"
          (click)="selectFirstItem()"><i class="icon-search"></i>
  </button>
</div>

@if (nothingFoundTemplate) {
  <ng-container *ngTemplateOutlet="nothingFoundTemplate"></ng-container>
}

<ng-template #defaultItemTemplate let-model="item">{{ getValueByFieldName(model) }}</ng-template>

<ng-template #ngbItemTemplate let-result="result">
  <ng-container
    *ngTemplateOutlet="itemTemplate; context: { $implicit: result, item: result }"
  ></ng-container>
</ng-template>
